import React, { useRef, useState, useEffect } from 'react'

import Icon from '../icon'

import * as S from './styles'

import IProps from './props'

const MessageInput = ({ onSend }: IProps) => {
  const inputRef = useRef<HTMLTextAreaElement>(null)
  const [inputValue, setInputValue] = useState('')

  const adjustTextareaHeight = () => {
    if (inputRef.current) {
      inputRef.current.style.height = '20px'
      inputRef.current.style.height = `${inputRef.current.scrollHeight}px`
    }
  }

  useEffect(() => {
    if (inputValue === '') adjustTextareaHeight()
  }, [inputValue])

  const handleInputChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    setInputValue(event.target.value)
    adjustTextareaHeight()
  }

  const handleClick = () => {
    if (inputValue) {
      onSend(inputValue)
      setInputValue('')
    }
  }

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      e.preventDefault()
      handleClick()
    }
  }

  return (
    <S.Container>
      <S.Input
        ref={inputRef}
        placeholder="Escreva uma mensagem"
        value={inputValue}
        onChange={handleInputChange}
        onKeyDown={handleKeyDown}
      />
      <S.IconContainer onClick={handleClick}>
        <Icon name="send-message" />
      </S.IconContainer>
    </S.Container>
  )
}

export default MessageInput
